/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).slideToggle();
      } );

      $( 'button.easy-toggle-slide-toggle' ).on( 'toggleBefore', function( event ) {
        const target = $( this ).data( 'toggle-target' );
        $( target ).slideToggle();
      } );


      $( document ).on( 'keydown', function( event ) {
        if ( $( ':focus' ).closest( '.menu--grandchildren' ).length ) {
          const focusedElement = $( ':focus' );
          const container = focusedElement.closest( '.menu--grandchildren' ).get( 0 );
          const focusables = $( container ).find( 'a, button' );
          const firstFocusable = focusables.get( 0 );
          const lastFocusable = focusables.get( focusables.length - 1 );

          if ( event.key === 'Tab' ) {
            if ( event.shiftKey ) {
              if ( focusedElement.get( 0 ) === firstFocusable ) {
                lastFocusable.focus();
                event.preventDefault();
              }
            } else {
              if ( focusedElement.get( 0 ) === lastFocusable ) {
                firstFocusable.focus();
                event.preventDefault();
              }
            }
          }
        } else {
          return;
        }
      } );

      $( '.primary-menu-item > button' ).on( 'toggleAfter', function() {
        const dropdownMenu = $( this ).attr( 'data-toggle-target' );
        const isOpen = $( dropdownMenu ).hasClass( 'is-open' );

        if ( !isOpen ) {
          setDropdownFocusable( dropdownMenu, true );
        } else {
          setDropdownFocusable( dropdownMenu, false );
        }
      } );

      function setDropdownFocusable( dropdownMenu, enabled ) {
        if ( enabled ) {
          $( dropdownMenu ).find( 'a, button' ).removeAttr( 'tabindex' );
        } else {
          $( dropdownMenu ).find( 'a, button' ).attr( 'tabindex', -1 );
        }
      }

      $( '.a11y-skip-link' ).click( function( e ) {
        let wpadminBarHeight = 0;
        if ( $( '#wpadminbar' ).length > 0 ) {
          wpadminBarHeight = $( '#wpadminbar' ).outerHeight();
        }
        const headerHeight = $( 'header.navbar' ).outerHeight();

        $( 'html,body' ).animate( {
          scrollTop: $( '.main > *:first-child' ).offset().top - ( headerHeight + wpadminBarHeight ),
        }, 'slow' );
        $( '.main > *:first-child' ).attr( 'tabindex', '0' ).focus();
      } );

      if ( $( '.navbar .alert-banner' ).length && !localStorage.getItem( 'wyandot_alert_banner_dismissed' ) ) {
        $( '.alert-banner' ).show();
        addAlertBannerHeights();
      }

      $( '.alert-banner .close-alert' ).on( 'click', function() {
        removeAlertBannerHeights();
      } );

      function addAlertBannerHeights() {
        const root = document.querySelector( ':root' );
        const navbarHeight = parseInt( getComputedStyle( document.documentElement ).getPropertyValue( '--navbarHeight' ) );
        console.log( navbarHeight );
        const topOffset = getComputedStyle( document.documentElement ).getPropertyValue( '--topOffset' );
        const alertBannerHeight = parseInt( $( '.navbar .alert-banner' ).outerHeight() );

        const newNavbarHeight = ( navbarHeight + alertBannerHeight ) + 'px';
        const newTopOffset = topOffset.slice( 0, -1 ) + ' + ' + alertBannerHeight + 'px)';

        root.style.setProperty( '--navbarHeight', newNavbarHeight );
        root.style.setProperty( '--topOffset', newTopOffset );
        root.style.setProperty( '--alertBannerHeight', alertBannerHeight + 'px' );
      }

      function removeAlertBannerHeights() {
        const root = document.querySelector( ':root' );
        const navbarHeight = getComputedStyle( document.documentElement ).getPropertyValue( '--navbarHeight' );
        const topOffset = getComputedStyle( document.documentElement ).getPropertyValue( '--topOffset' );
        const alertBannerHeight = getComputedStyle( document.documentElement ).getPropertyValue( '--alertBannerHeight' );

        const newNavbarHeight = ( parseInt( navbarHeight ) - parseInt( alertBannerHeight ) ) + 'px';
        const newTopOffset = topOffset.replace( ' + ' + parseInt( alertBannerHeight ) + 'px', '' );

        $( '.alert-banner' ).remove();
        root.style.setProperty( '--alertBannerHeight', '0px' );
        root.style.setProperty( '--navbarHeight', newNavbarHeight );
        root.style.setProperty( '--topOffset', newTopOffset );
        localStorage.setItem( 'wyandot_alert_banner_dismissed', true );
      }

      $( document ).on( 'click', '.js-init-video, .wp-block-click-to-play a', function( e ) {
        e.preventDefault();

        let videoUrl = $( this ).attr( 'href' );
        let autoplayMatch = videoUrl?.match( /[?&]autoplay=([01])/ ) || ['autoplay=0'];
        autoplayMatch = autoplayMatch[0].replace( /[?&]/, '' );
        videoUrl = videoUrl.replace( /([?&])autoplay=[01](&|$)/, '$1' ).replace( /\?$/, '' );

        $.magnificPopup.open( {
          items: {
            src: videoUrl,
          },
          type: 'iframe',
          iframe: {
            markup: `
              <div class="mfp-iframe-scaler">
                <div class="mfp-close"></div>
                <iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>
              </div>
            `,
            patterns: {
              youtube: {
                index: 'youtube.com/',
                id: 'v=',
                src: `//www.youtube.com/embed/%id%?${autoplayMatch}`,
              },
              vimeo: {
                index: 'vimeo.com/',
                id: '/',
                src: `//player.vimeo.com/video/%id%?${autoplayMatch}`,
              },
              gmaps: {
                index: '//maps.google.',
                src: '%id%&output=embed',
              },
            },
            srcAction: 'iframe_src',
          },
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false,
          callbacks: {
            open: function() {
              $( 'video' ).trigger( 'pause' );
            },
            close: function() {
              $( 'video' ).trigger( 'play' );
            },
          },
        } );
      } );

      /* Disable duplicate entries on form submit */
      $( function() {
        $( document ).on( 'submit', '.form-skin', function() {
          // Disable submit button
          $( this ).find( 'button[type="submit"]' ).prop( 'disabled', true ).css( 'opacity', 0.2 );
        } );
      } );

      function handleMobileChange( event ) {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        if ( event.matches ) {
          if ( $( '.primary-nav' ).length > 0 ) {
            $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );

            $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
          }
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 768px)' );
      handleMobileChange( mobileSize );
      mobileSize.addEventListener( 'change', handleMobileChange );

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }

      /* Lazyload all embeds */
      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }

      /* Set up arias for blog sidebar toggles */
      toggleBlogSidebarAriaVisibility();

      $( window ).on( 'resize', function() {
        toggleBlogSidebarAriaVisibility();
      } );

      function toggleBlogSidebarAriaVisibility() {
        if ( window.innerWidth > 1024 ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', false );
        } else if ( window.innerWidth <= 1024 && !$( '.blog__sidebar-inner' ).hasClass( 'is-open' ) ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', true );
        }
      }
    },
    finalize: function() {
    },
    Throttle: class Throttle {
      constructor( callback, delay ) {
        this.callback = callback;
        this.delay = delay;
        this.throttlePause = false;
        this.waitingArgs = null;
        this.timeoutFunc = this.timeoutFunc.bind( this );
      }
      run( ...args ) {
        if ( this.throttlePause ) {
          this.waitingArgs = args;
          return;
        }
        this.callback( ...args );
        this.throttlePause = true; // Set throttle pause state for this instance
        setTimeout( this.timeoutFunc, this.delay );
      }
      timeoutFunc() {
        if ( this.waitingArgs ) {
          this.callback( ...this.waitingArgs );
          this.waitingArgs = null;
          setTimeout( this.timeoutFunc, this.delay );
        } else {
          this.throttlePause = false;
        }
      }
    },
    Debounce: class Debounce {
      constructor( callback, time ) {
        this.callback = callback;
        this.time = time;
        this.debounceTimer;
      }
      run() {
        window.clearTimeout( this.debounceTimer );
        this.debounceTimer = window.setTimeout( this.callback, this.time );
      }
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
